import { storageService } from '@/services/storage'

import type { QuoteDocumentPro } from './QuoteTypes'

const STORAGE_KEY = 'masterhub.quote-builder-pro.history.v1'
const AUTOSAVE_KEY = 'masterhub.quote-builder-pro.autosave.v1'

let memoryDocs: QuoteDocumentPro[] | null = null
let memoryAutosave: QuoteDocumentPro | null = null

/**
 * QuoteHistory — persistence + autosave for Quote Builder PRO.
 */
export class QuoteHistory {
  list(): QuoteDocumentPro[] {
    return readDocs()
  }

  save(doc: QuoteDocumentPro): QuoteDocumentPro {
    const docs = readDocs().filter((d) => d.id !== doc.id)
    const next = [{ ...doc, updatedAt: new Date().toISOString() }, ...docs].slice(0, 50)
    writeDocs(next)
    return next[0]!
  }

  load(id: string): QuoteDocumentPro | null {
    return readDocs().find((d) => d.id === id) ?? null
  }

  autosave(doc: QuoteDocumentPro): void {
    memoryAutosave = doc
    if (typeof window === 'undefined') return
    storageService.setJSON(AUTOSAVE_KEY, doc)
  }

  loadAutosave(): QuoteDocumentPro | null {
    if (typeof window === 'undefined') return memoryAutosave
    return storageService.getJSON<QuoteDocumentPro | null>(AUTOSAVE_KEY, null)
  }

  clearAutosave(): void {
    memoryAutosave = null
    if (typeof window !== 'undefined') storageService.remove(AUTOSAVE_KEY)
  }
}

function readDocs(): QuoteDocumentPro[] {
  if (typeof window === 'undefined') return memoryDocs ?? []
  return storageService.getJSON<QuoteDocumentPro[]>(STORAGE_KEY, [])
}

function writeDocs(docs: QuoteDocumentPro[]): void {
  memoryDocs = docs
  if (typeof window === 'undefined') return
  storageService.setJSON(STORAGE_KEY, docs)
}

export const quoteHistory = new QuoteHistory()
